( function( app ) {
  const COMPONENT = {
    init: function() {
      cardContentPositioning();
      $( window ).on( 'resize', function() {
        cardContentPositioning();
      } );
      function cardContentPositioning() {
        if ( window.innerWidth > 1024 ) {
          $( '.icon-link-cards__card-content' ).each( function() {
            const hoverContent = $( this ).find( '.icon-link-cards__hover-content' );
            if ( hoverContent.length === 0 ) {
              return;
            }
            const descriptionHeight = hoverContent.outerHeight() + 16;
            $( this ).css( {
              'opacity': '1',
              'transform': `translateY(${descriptionHeight}px)`,
            } );

            // Force a reflow before adding the transition to prevent jumping on load
            // and don't add it if prefers reduced motion is true
            if ( window.hasMotion ) {
              requestAnimationFrame( () => {
                $( this ).css( 'transition-duration', '0.5s' );
              } );
            }
          } );
        } else {
          $( '.icon-link-cards__card-content' ).each( function() {
            $( this ).css( {
              'opacity': '1',
              'transform': `translateY(0px)`,
            } );
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'icon-link-cards', COMPONENT );
} )( app );
